import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getFeedingHandover, getFeedingPowerOn, getFeedingTotal, getFeedingTable, getFeedingRatio, getFeedingTrend } from '@/service/Feeding/FeedingForm';
// 交接班时间
export var useFeedingHandover = function useFeedingHandover() {
  var handoverData = ref({
    start_time: '',
    end_time: '',
    show_time: '',
    runing_time: ''
  });
  // 获取交接班时间
  var getFeedingHandoverAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getFeedingHandover();
          case 2:
            data = _context.sent;
            handoverData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getFeedingHandoverAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [handoverData, getFeedingHandoverAsync];
};
// 开关机时间
export var useFeedingPowerOn = function useFeedingPowerOn() {
  var powerOnList = ref([]);
  // 获取开关机时间
  var getFeedingPowerOnAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getFeedingPowerOn();
          case 2:
            data = _context2.sent;
            powerOnList.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getFeedingPowerOnAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [powerOnList, getFeedingPowerOnAsync];
};
// 进料统计
export var useFeedingTotal = function useFeedingTotal(params) {
  var feedingTotal = ref({
    proValue: '',
    feedCarNumber: '',
    feedFreight: ''
  });
  // 获取进料统计
  var getFeedingTotalAsync = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getFeedingTotal(params.value);
          case 2:
            data = _context3.sent;
            feedingTotal.value = data;
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getFeedingTotalAsync() {
      return _ref3.apply(this, arguments);
    };
  }();
  return [feedingTotal, getFeedingTotalAsync];
};
// 进料统计表格
export var useFeedingTable = function useFeedingTable(params) {
  var feedingTable = ref([]);
  // 进料统计表格
  var getFeedingTableAsync = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getFeedingTable(params.value);
          case 2:
            data = _context4.sent;
            feedingTable.value = data.list;
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getFeedingTableAsync() {
      return _ref4.apply(this, arguments);
    };
  }();
  return [feedingTable, getFeedingTableAsync];
};
// 各平台进料量对比
export var useFeedingRatio = function useFeedingRatio(params) {
  var feedingRatio = ref({
    feedWeight: [],
    feedFreight: []
  });
  // 各平台进料量对比
  var getFeedingRatioAsync = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getFeedingRatio(params.value);
          case 2:
            data = _context5.sent;
            feedingRatio.value = data;
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getFeedingRatioAsync() {
      return _ref5.apply(this, arguments);
    };
  }();
  return [feedingRatio, getFeedingRatioAsync];
};
// 进料量趋势
export var useFeedingTrend = function useFeedingTrend(params) {
  var feedingTrend = ref([]);
  // 进料量趋势
  var getFeedingTrendAsync = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getFeedingTrend(params.value);
          case 2:
            data = _context6.sent;
            feedingTrend.value = data.list;
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getFeedingTrendAsync() {
      return _ref6.apply(this, arguments);
    };
  }();
  return [feedingTrend, getFeedingTrendAsync];
};